if (!customElements.get('tv-daily-draw')) {
  customElements.define(
    'tv-daily-draw',
    class TvDailyDraw extends HTMLElement {
      connectedCallback() {
        this.panel = this.querySelector('.tv-daily-draw__panel');
        this.closeButtons = this.querySelectorAll('[data-tv-daily-draw-close]');
        this.openButtons = document.querySelectorAll(
          `[aria-controls="${this.id}"]`
        );
        this.directionButtons = this.querySelectorAll(
          '[data-tv-daily-draw-direction]'
        );
        this.backButton = this.querySelector('[data-tv-daily-draw-back]');
        this.hostSection = this.closest('.section-header');
        this.stepTimer = null;

        /* 初始打开默认是第一页 choose */
        this.dataset.step = 'choose';

        this.open = this.open.bind(this);
        this.close = this.close.bind(this);
        this.handleKeydown = this.handleKeydown.bind(this);
        this.backToChoose = this.backToChoose.bind(this);

        this.openButtons.forEach((button) => {
          button.addEventListener('click', this.open);
        });

        this.closeButtons.forEach((button) => {
          button.addEventListener('click', this.close);
        });

        this.directionButtons.forEach((button) => {
          button.addEventListener('click', () => this.selectDirection(button));
        });

        this.backButton?.addEventListener('click', this.backToChoose);
      }

      disconnectedCallback() {
        this.openButtons.forEach((button) => {
          button.removeEventListener('click', this.open);
        });

        this.closeButtons.forEach((button) => {
          button.removeEventListener('click', this.close);
        });

        this.backButton?.removeEventListener('click', this.backToChoose);

        window.clearTimeout(this.stepTimer);
        document.removeEventListener('keydown', this.handleKeydown);
        document.body.classList.remove('tv-daily-draw-is-open');
        this.hostSection?.classList.remove('tv-daily-draw-host-open');
      }

      open(event) {
        this.previouslyFocused = event.currentTarget;

        /* 每次从头部图标打开都回到第一页 */
        this.dataset.step = 'choose';

        this.directionButtons.forEach((button) => {
          button.setAttribute('aria-pressed', 'false');
        });

        this.classList.add('is-open');
        this.setAttribute('aria-hidden', 'false');
        this.panel?.removeAttribute('inert');

        this.openButtons.forEach((button) => {
          button.setAttribute('aria-expanded', 'true');
        });

        document.body.classList.add('tv-daily-draw-is-open');
        this.hostSection?.classList.add('tv-daily-draw-host-open');
        document.addEventListener('keydown', this.handleKeydown);

        const scrollArea = this.querySelector('.tv-daily-draw__scroll-area');
        if (scrollArea) scrollArea.scrollTop = 0;

        const closeButton = this.querySelector('.tv-daily-draw__close');
        if (closeButton) {
          closeButton.focus({ preventScroll: true });
        }
      }

      close() {
        window.clearTimeout(this.stepTimer);

        this.classList.remove('is-open');
        this.setAttribute('aria-hidden', 'true');
        this.panel?.setAttribute('inert', '');

        this.openButtons.forEach((button) => {
          button.setAttribute('aria-expanded', 'false');
        });

        document.body.classList.remove('tv-daily-draw-is-open');
        // 🌙 关闭每日竹签时，清除所有仪式动画状态
document.body.classList.remove("ritual-step-1", "ritual-step-2", "ritual-step-3");
        this.hostSection?.classList.remove('tv-daily-draw-host-open');
        document.removeEventListener('keydown', this.handleKeydown);

        this.dataset.step = 'choose';
        this.classList.remove('is-transitioning'); // 🌿 关闭时清除过渡状态

        if (this.previouslyFocused) {
          this.previouslyFocused.focus({ preventScroll: true });
        }
      }

      selectDirection(selectedButton) {
        window.clearTimeout(this.stepTimer);

        this.directionButtons.forEach((button) => {
          button.setAttribute('aria-pressed', 'false');
        });

        selectedButton.setAttribute('aria-pressed', 'true');

/* 🌙 点击方向后：先进入过渡状态，再进入第二页 */
this.classList.add('is-transitioning');

this.stepTimer = window.setTimeout(() => {
  this.dataset.step = 'draw';

  const scrollArea = this.querySelector(
    '.tv-daily-draw__scroll-area'
  );

  if (scrollArea) scrollArea.scrollTop = 0;

  /* 🌿 第二页显示后，结束过渡状态 */
  window.setTimeout(() => {
    this.classList.remove('is-transitioning');
  }, 120);
}, 500);
      }

      backToChoose(event) {
        event?.preventDefault();
        window.clearTimeout(this.stepTimer);

        this.dataset.step = 'choose';
        this.classList.remove('is-transitioning'); // 🌿 返回第一页时清除过渡状态
        // 🌙 返回第一页时，清除所有仪式动画状态
document.body.classList.remove("ritual-step-1", "ritual-step-2", "ritual-step-3");

        this.directionButtons.forEach((button) => {
          button.setAttribute('aria-pressed', 'false');
        });

        const scrollArea = this.querySelector(
          '.tv-daily-draw__scroll-area'
        );

        if (scrollArea) scrollArea.scrollTop = 0;
      }

      handleKeydown(event) {
        if (event.key === 'Escape') {
          this.close();
          return;
        }

        if (event.key !== 'Tab') return;

        const focusable = Array.from(
          this.panel.querySelectorAll(
            'a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])'
          )
        ).filter((element) => !element.hasAttribute('hidden'));

        if (focusable.length === 0) return;

        const first = focusable[0];
        const last = focusable[focusable.length - 1];

        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      }
    }
  );
}
/* =========================
   每日竹签：按钮点击统一控制
   说明：
   1. 只绑定一次点击事件，避免重复触发
   2. 点击按钮时启动水波纹
   3. 同时启动 ritual-step-1 / ritual-step-2
   4. 不使用旧版 span 水波，避免冲突
   ========================= */

document.addEventListener("click", function (event) {
  // 🌿 找到当前点击的每日竹签按钮
  const button = event.target.closest(".tv-daily-draw__cta");

  // 如果点的不是按钮，直接结束
  if (!button) return;
    // 🌿 找到当前 Daily Bamboo Draw 组件
  const drawer = button.closest("tv-daily-draw");

  // 🌙 找到第一页被选中的方向按钮
  const selectedDirection = drawer?.querySelector(
    '[data-tv-daily-draw-direction][aria-pressed="true"] .tv-daily-draw__direction-label'
  );

  // 🌿 读取被选中的按钮标题，例如 Protection / Love / Calm
  const selectedTitle = selectedDirection
    ? selectedDirection.textContent.trim()
    : "Protection";

// 🌙 每个方向准备多条今日指引：英文 + 中文
const dailyMessages = {
  Protection: [
    {
      en: "Let stillness become your boundary.",
    },
    {
      en: "Not every energy deserves your opening.",
    },
    {
      en: "Protect your peace before you explain your heart.",
    },
    {
      en: "A quiet boundary is still a sacred boundary.",
    },
    {
      en: "Step back from what drains your spirit.",
    },
    {
      en: "Your calm is not weakness. It is protection.",
    },
    {
      en: "Do not carry what was never yours to hold.",
    },
    {
      en: "Guard your light without closing your heart.",
    }
  ],

  Prosperity: [
    {
      en: "Open gently to what is ready to grow.",
    },
    {
      en: "Abundance begins where fear loosens its grip.",
    },
    {
      en: "Let small blessings teach you how to receive more.",
    },
    {
      en: "Growth does not need to be forced today.",
    },
    {
      en: "What is meant for you can arrive softly.",
    },
    {
      en: "Make room, and fortune will know where to land.",
    },
    {
      en: "Your next harvest begins with one steady choice.",
    },
    {
      en: "Prosperity follows the energy you consistently honor.",
    }
  ],

  Love: [
    {
      en: "Receive with softness, and give without losing yourself.",
    },
    {
      en: "Love should feel like return, not disappearance.",
    },
    {
      en: "Let your heart stay open, but not unguarded.",
    },
    {
      en: "The right connection will not ask you to abandon yourself.",
    },
    {
      en: "Softness is powerful when it has a center.",
    },
    {
      en: "Do not chase what cannot meet you with presence.",
    },
    {
      en: "Let affection be mutual, not imagined.",
    },
    {
      en: "Your tenderness deserves a safe place to bloom.",
    }
  ],

  Calm: [
    {
      en: "Return to the quiet place within you.",
    },
    {
      en: "You do not have to answer everything today.",
    },
    {
      en: "Let the noise pass without becoming part of you.",
    },
    {
      en: "Peace is found in the breath before reaction.",
    },
    {
      en: "Slow down enough to hear what your spirit knows.",
    },
    {
      en: "Nothing needs to be forced into clarity today.",
    },
    {
      en: "Let your body arrive before your thoughts run ahead.",
    },
    {
      en: "Still water reflects what rushing water cannot.",
    }
  ],

  Clarity: [
    {
      en: "Let the unnecessary fall away.",
    },
    {
      en: "The answer becomes clearer when you stop gripping it.",
    },
    {
      en: "Look for what feels simple, steady, and true.",
    },
    {
      en: "Confusion softens when you return to what matters.",
    },
    {
      en: "Do not mistake urgency for truth.",
    },
    {
      en: "A clear path may begin as a quiet no.",
    },
    {
      en: "Your intuition speaks softly, but it does not disappear.",
    },
    {
      en: "What remains after stillness is worth listening to.",
    }
  ],

  Renewal: [
    {
      en: "Begin again, lighter than before.",
    },
    {
      en: "You are allowed to outgrow an old version of yourself.",
    },
    {
      en: "Release what has already completed its lesson.",
    },
    {
      en: "A new cycle begins when you stop feeding the old one.",
    },
    {
      en: "Let today be a small doorway, not a final answer.",
    },
    {
      en: "Change can arrive quietly and still be real.",
    },
    {
      en: "You are not late. You are becoming.",
    },
    {
      en: "The old weight leaves when you stop calling it home.",
    }
  ]
};

  // 🌿 找到结果标题和结果文字
  const resultTitle = drawer?.querySelector("[data-tv-result-title]");
  const resultText = drawer?.querySelector("[data-tv-result-text]");

 // 🌙 从当前方向里随机抽一条今日指引
const messageList = dailyMessages[selectedTitle] || dailyMessages.Protection;
const randomMessage =
  messageList[Math.floor(Math.random() * messageList.length)];

// 🌿 更新结果标题
if (resultTitle) {
  resultTitle.textContent = selectedTitle;
}

// 🌙 更新英文今日指引
if (resultText) {
  resultText.textContent = randomMessage.en;
}

// 🌙 更新中文今日指引
const resultTextZh = drawer?.querySelector("[data-tv-result-text-zh]");
if (resultTextZh) {
  resultTextZh.textContent = randomMessage.zh;
}


// 🌙 播放按钮发光 + 背景呼吸模糊
// 说明：不做水波扩散，只让按钮和第二页背景有呼吸感

button.classList.remove("tv-breath-active");
drawer?.classList.remove("tv-bg-breath-active");

// 🌿 强制刷新动画状态，保证每次点击都能重新播放
void button.offsetWidth;

button.classList.add("tv-breath-active");
drawer?.classList.add("tv-bg-breath-active");

// 🧹 呼吸动画结束后移除 class，方便下次点击重新播放
window.setTimeout(function () {
  button.classList.remove("tv-breath-active");
  drawer?.classList.remove("tv-bg-breath-active");
}, 1500);

// 🌫 重置旧的仪式状态，避免多次点击叠加
document.body.classList.remove("ritual-step-1", "ritual-step-2", "ritual-step-3");

  // 🌿 Step 1：进入仪式状态
  document.body.classList.add("ritual-step-1");

  // 🌊 Step 2：稍后进入呼吸状态
  window.setTimeout(function () {
    document.body.classList.remove("ritual-step-1");
    document.body.classList.add("ritual-step-2");
  }, 1800);
// 🌙 Step 3：呼吸之后，显示今日签文结果卡片
window.setTimeout(function () {
  document.body.classList.remove("ritual-step-2");
  document.body.classList.add("ritual-step-3");
}, 1500);

}); // 🌿 结束第二页 Let the sign appear 按钮点击事件



/* =========================
   每日竹签：分享 / 复制签文
   说明：
   1. Share：优先调用手机/浏览器系统分享
   2. Copy Sign：复制今日签文文字
   3. 不影响原来的抽签逻辑
   ========================= */

document.addEventListener("click", async function (event) {
  const shareButton = event.target.closest("[data-tv-share-sign]");
  const copyButton = event.target.closest("[data-tv-copy-sign]");

  // 如果点的不是分享按钮，也不是复制按钮，直接结束
  if (!shareButton && !copyButton) return;

  const drawer = event.target.closest("tv-daily-draw");
  if (!drawer) return;

  const title = drawer.querySelector("[data-tv-result-title]")?.textContent?.trim() || "";
  const text = drawer.querySelector("[data-tv-result-text]")?.textContent?.trim() || "";
  const textZh = drawer.querySelector("[data-tv-result-text-zh]")?.textContent?.trim() || "";
  const status = drawer.querySelector("[data-tv-share-status]");

  const signText = [
    "Today's Sign",
    title,
    text,
    textZh,
    "",
    "Daily Bamboo Draw · Tao Vessel",
    window.location.href
  ].filter(Boolean).join("\n");

  function showStatus(message) {
    if (!status) return;

    status.textContent = message;
    status.classList.add("is-visible");

    window.clearTimeout(status._tvTimer);
    status._tvTimer = window.setTimeout(function () {
      status.classList.remove("is-visible");
    }, 1800);
  }

  // 🌙 Copy Sign：复制签文
  if (copyButton) {
    try {
      await navigator.clipboard.writeText(signText);
      showStatus("Sign copied");
    } catch (error) {
      // 备用方案：老浏览器复制
      const textarea = document.createElement("textarea");
      textarea.value = signText;
      textarea.setAttribute("readonly", "");
      textarea.style.position = "fixed";
      textarea.style.left = "-9999px";
      document.body.appendChild(textarea);
      textarea.select();

      try {
        document.execCommand("copy");
        showStatus("Sign copied");
      } catch (copyError) {
        showStatus("Copy failed");
      }

      textarea.remove();
    }
  }

  // 🌿 Share：系统分享
  if (shareButton) {
    if (navigator.share) {
      try {
        await navigator.share({
          title: "Daily Bamboo Draw",
          text: signText,
          url: window.location.href
        });

        showStatus("Shared");
      } catch (error) {
        showStatus("Share cancelled");
      }
    } else {
      // 桌面端不支持系统分享时，自动复制
      try {
        await navigator.clipboard.writeText(signText);
        showStatus("Sharing not supported. Sign copied.");
      } catch (error) {
        showStatus("Sharing not supported");
      }
    }
  }
});